if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.statusElement = this.querySelector('[data-predictive-search-status]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(window.innerWidth < 990) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(window.innerWidth <= 990) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          if (!this.isOpen) return;
          const options = Array.from(
            this.resultsContainer.querySelectorAll('[role="option"]')
          );
          if (!options.length) return;
          e.preventDefault();
          const currentId = this.input.getAttribute('aria-activedescendant');
          const currentIndex = options.findIndex(opt => opt.id === currentId);
          let nextIndex;
          if (e.key === 'ArrowDown') {
            nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
          } else {
            nextIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
          }
          options.forEach(opt => opt.classList.remove('is-active'));
          options[nextIndex].classList.add('is-active');
          this.input.setAttribute('aria-activedescendant', options[nextIndex].id);
          options[nextIndex].scrollIntoView({ block: 'nearest' });
          return;
        }

        if (e.key === 'Enter') {
          const activeId = this.input.getAttribute('aria-activedescendant');
          if (activeId && this.isOpen) {
            const activeOption = this.resultsContainer.querySelector(`#${activeId}`);
            const link = activeOption && activeOption.querySelector('a');
            if (link) {
              e.preventDefault();
              link.click();
              return;
            }
          }
        }

        if (e.key === 'Escape') {
          if (!this.input.value) {
            if (this.drawer) {
              this.drawer.parentElement.parentElement.toggleDrawer();
            }
            return;
          }
          this.close();
        }
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.input.removeAttribute('aria-activedescendant');
        this.resultsContainer.querySelectorAll('[role="option"]').forEach(opt => opt.classList.remove('is-active'));
        this.open();
        if (this.statusElement) {
          const count = this.resultsContainer.querySelectorAll('[role="option"]').length;
          if (count === 1) {
            this.statusElement.textContent = this.statusElement.dataset.countOne || `${count}`;
          } else if (count > 1) {
            this.statusElement.textContent = (this.statusElement.dataset.countOther || '__COUNT__').replace('__COUNT__', count);
          } else {
            this.statusElement.textContent = '';
          }
        }

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.input.setAttribute('aria-expanded', 'true');
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
      if (this.statusElement) this.statusElement.textContent = '';
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
